import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/tickets-statuses/$')({
  beforeLoad: () => {
    throw redirect({ to: window.location.pathname.split('/')?.toSpliced(3, 1, 'settings/ticket-lifecycle').join('/'), search: true });
  },
});
